import React, { useEffect, useState } from 'react';
import { removeLoginId, removeToken } from './authservice';
import './logout.css';
import { useNavigate } from 'react-router-dom';



export default function Logout({loginstate, setLoginState }) {

  const [logouttext, setLogOutText] = useState('You have been logged out. Redirecting to home page...');
  const navigate = useNavigate();


  useEffect(() => {
    if (loginstate.isLoggedIn === true){
      removeToken();
      removeLoginId();
      setLoginState({isLoggedIn: false, loginId: null});

      setTimeout(() => {
        window.location.reload();
      }, 1500);
      setTimeout(() => {
        navigate('/');
      }, 1500);


  
    }
    else{
      setLogOutText('You are not logged in.');
    }
  }, [])

  return (
    <div className="logoutbody">
        <div className="logoutcontainer">
          <div className="logouttitle">
            <h2 style={{ fontWeight: '400', textAlign: 'center' }}>{logouttext}</h2>
          </div >
        </div >
    </div >
  )
}
